import { axiosInstance } from "@/axios/config";
import { store } from "@/store";

export const FUNDING_MANAGER_QUESTIONNAIRE_ALLOWED_ROUTES = [
  "FundingQuestionAndAnswer",
  "questionnaire_details",
  "SignIn",
  "login",
];

export function isFundingManagerRole() {
  return localStorage.getItem("role") === "2";
}

let lastQuestionnaireCheckAt = 0;
const QUESTIONNAIRE_CHECK_TTL_MS = 15000;

export function applyPendingQuestionnaireState(payload) {
  const hasPending = !!(payload && payload.id);
  store.state.NextUnansweredQuestion = hasPending ? payload : null;
  store.state.fundingManagerBlockedByQuestionnaire = hasPending;
  store.state.pendingQuestionnaireCount = hasPending
    ? payload.pending_count || 1
    : 0;
  return hasPending;
}

export async function refreshPendingQuestionnaire(force = false) {
  if (!isFundingManagerRole()) {
    applyPendingQuestionnaireState(null);
    return null;
  }

  const recentlyChecked =
    !force &&
    Date.now() - lastQuestionnaireCheckAt < QUESTIONNAIRE_CHECK_TTL_MS;

  if (
    recentlyChecked &&
    !store.state.fundingManagerBlockedByQuestionnaire
  ) {
    return store.state.NextUnansweredQuestion;
  }

  try {
    const response = await axiosInstance.get(
      "/employee/funding-manager/getNextUnansweredQuestion"
    );
    lastQuestionnaireCheckAt = Date.now();
    applyPendingQuestionnaireState(response.data.payload);
    return response.data.payload;
  } catch (error) {
    console.error("Failed to check pending questionnaire:", error);
    return null;
  }
}

export function shouldBlockFundingManagerRoute(routeName) {
  return (
    isFundingManagerRole() &&
    store.state.fundingManagerBlockedByQuestionnaire &&
    !FUNDING_MANAGER_QUESTIONNAIRE_ALLOWED_ROUTES.includes(routeName)
  );
}

export function redirectToRequiredQuestionnaire(router) {
  store.state.showFundingQuestionnaireRequiredAlert = true;
  router.push({
    name: "FundingQuestionAndAnswer",
    query: { required: "1" },
  });
}
